enum Router {
    HOME = '/',
    SCHEDULE = '/matches',
    MATCH = '/matches/:matchId',
    BETS = '/bets',
    TOURNAMENT_BETS = '/tournament-bets',
    PROFILE = '/profile',
    USER = '/user/:userId',
    UNSUBSCRIBE = '/unsubscribe',
    LOGIN = '/login',
    REGISTER = '/register',
    RESTORE_PASSWORD_LINK = '/reset-password',
    RESTORE_PASSWORD = '/reset-password/:sessionId',
    NOT_FOUND = '/error/404',
    UNAVAILABLE = '/error/503',
}

export { Router };
